var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed, reaction } from 'mobx';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Api } from '@app/Api';
import { GateProcessStage, ProjectState, ProjectType } from '@app/AppConstants';
import { GateTabs } from '@app/Components/GateTabs/GateTabs';
import { GateTabsDates } from '@app/Components/GateTabsDates/GateTabsDates';
import { TgTabsContent } from '@app/Components/TgTabs/TgTabsContent';
import { SkippedGateView } from '@app/Pages/ProjectView/ProjectViewTabs/Components/SkippedGateView/SkippedGateView';
import { OnHoldGateView } from '@app/Pages/ProjectView/ProjectViewTabs/Components/OnHoldGateView/OnHoldGateView';
import { Link } from '@app/Components/Link/Link';
import { Button } from '@app/Components/Button/Button';
export var GateTabsWrapper = /** @class */ (function (_super) {
    __extends(GateTabsWrapper, _super);
    function GateTabsWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._gates = [];
        _this._saveGate = function (gateId) { return __awaiter(_this, void 0, void 0, function () {
            var model;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        model = {
                            value: gateId.toString(),
                            projectId: this.props.projectId
                        };
                        return [4 /*yield*/, Api.secured.putCurrentProjectGate({ body: model })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        reaction(function () { return _this.currentGate; }, function () {
            if (_this.props.onChangeCurrentGateHandler) {
                _this.props.onChangeCurrentGateHandler(_this.currentGate);
            }
        });
        return _this;
    }
    GateTabsWrapper.prototype.updateGates = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadGates()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GateTabsWrapper.prototype.getGates = function () {
        return this._gates;
    };
    GateTabsWrapper.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadProjectGate()];
                    case 1:
                        _a.sent();
                        this._findCurrentGate();
                        return [4 /*yield*/, this._loadGates()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GateTabsWrapper.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.location !== prevProps.location) {
            this._findCurrentGate();
        }
    };
    GateTabsWrapper.prototype._findCurrentGate = function () {
        var match = /.*\/g-(\d{1,}).*/gi.exec(this.props.location.pathname);
        if (match && match[1]) {
            var parsed = parseInt(match[1]);
            if (this._currentGateId !== parsed) {
                this._currentGateId = parsed;
            }
        }
    };
    GateTabsWrapper.prototype._getDefaultGateLink = function () {
        if (this._gates.length < 1)
            return '';
        var match = this.props.match;
        var filtered = this._gates.filter(function (g) { return g.setupStatus === 'Approved'; });
        if (this._savedGateId) {
            return "".concat(match.url, "/g-").concat(this._savedGateId);
        }
        else if (filtered.length > 0) {
            return "".concat(match.url, "/g-").concat(filtered[filtered.length - 1].id);
        }
        else {
            return "".concat(match.url, "/g-").concat(this._gates[0].id);
        }
    };
    GateTabsWrapper.prototype._loadGates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, Api.secured.getApprovedGatesList({ projectId: this.props.projectId })];
                    case 1:
                        _a._gates = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GateTabsWrapper.prototype._loadProjectGate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gateId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Api.secured.getCurrentProjectGate({ projectId: this.props.projectId })];
                    case 1:
                        gateId = _a.sent();
                        if (gateId) {
                            this._savedGateId = gateId.body;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(GateTabsWrapper.prototype, "currentGate", {
        get: function () {
            var _this = this;
            return this._gates.find(function (g) { return g.id === _this._currentGateId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GateTabsWrapper.prototype, "isCurrentGateOnHold", {
        get: function () {
            return this.currentGate && this.currentGate.gateStage === GateProcessStage.OnHold;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GateTabsWrapper.prototype, "skipReason", {
        get: function () {
            return this.currentGate && this.currentGate.gateSkipReason;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GateTabsWrapper.prototype, "showMeetingButton", {
        get: function () {
            var _this = this;
            var _a, _b;
            var projectState = this.props.projectState;
            var skippedCurrentGate = (_b = (_a = this._gates) === null || _a === void 0 ? void 0 : _a.find(function (g) { return g.id === _this._currentGateId; })) === null || _b === void 0 ? void 0 : _b.gateSkipReason;
            return !(projectState === ProjectState.IsEmpty ||
                this.isCurrentGateOnHold ||
                skippedCurrentGate ||
                this._currentGateId === undefined);
        },
        enumerable: false,
        configurable: true
    });
    GateTabsWrapper.prototype.render = function () {
        var _a;
        var _b, _c, _d;
        var projectId = (_a = this.props, _a.projectId), match = _a.match, needToShowMeetingButton = _a.needToShowMeetingButton, children = _a.children, projectType = _a.projectType;
        var isMilestoneProject = projectType === ProjectType.Milestone;
        return (React.createElement(React.Fragment, null,
            React.createElement(GateTabs, { url: match.url, gates: this._gates, onClickHandler: this._saveGate },
                React.createElement(GateTabsDates, { meetingDate: (_b = this.currentGate) === null || _b === void 0 ? void 0 : _b.gateMeetingDate, meetingEndDate: (_c = this.currentGate) === null || _c === void 0 ? void 0 : _c.gateMeetingEndDate, forecastOrActualDate: (_d = this.currentGate) === null || _d === void 0 ? void 0 : _d.forecastOrActualDate, isMilestoneProject: isMilestoneProject }),
                needToShowMeetingButton && this.showMeetingButton && (React.createElement(Link, { key: projectId, to: "".concat(match.url, "/g-").concat(this._currentGateId, "/meeting") },
                    React.createElement(Button, { size: "sm", color: 'success' }, "Meeting")))),
            React.createElement(TgTabsContent, null,
                React.createElement(Switch, null,
                    this._currentGateId && (React.createElement(Route, { key: this._currentGateId, path: "".concat(match.url, "/g-").concat(this._currentGateId) },
                        this.skipReason && React.createElement(SkippedGateView, { reason: this.skipReason }),
                        this.currentGate && !this.skipReason && this.isCurrentGateOnHold && React.createElement(OnHoldGateView, null),
                        this.currentGate && !this.skipReason && !this.isCurrentGateOnHold && children)),
                    !this._currentGateId && this._gates.length > 0 && (React.createElement(Route, { path: "".concat(match.url) },
                        React.createElement(Redirect, { to: this._getDefaultGateLink() })))))));
    };
    __decorate([
        observable
    ], GateTabsWrapper.prototype, "_gates", void 0);
    __decorate([
        observable
    ], GateTabsWrapper.prototype, "_currentGateId", void 0);
    __decorate([
        observable
    ], GateTabsWrapper.prototype, "_savedGateId", void 0);
    __decorate([
        action.bound
    ], GateTabsWrapper.prototype, "_loadGates", null);
    __decorate([
        computed
    ], GateTabsWrapper.prototype, "currentGate", null);
    __decorate([
        computed
    ], GateTabsWrapper.prototype, "isCurrentGateOnHold", null);
    __decorate([
        computed
    ], GateTabsWrapper.prototype, "skipReason", null);
    __decorate([
        computed
    ], GateTabsWrapper.prototype, "showMeetingButton", null);
    GateTabsWrapper = __decorate([
        observer
    ], GateTabsWrapper);
    return GateTabsWrapper;
}(React.PureComponent));
